import { AuthDetails, IModule, ITKeyApi, Share, ShareStore } from "@tkey-singularity/common-types";
import BN from "bn.js";

import { getShareFromLocalStorage, storeShareOnLocalStorage } from "./LocalStorageHelpers";

export const TORUS_STORAGE_MODULE_NAME = "torusStorage";

class TorusStorageModule implements IModule {
  moduleName: string;

  tbSDK: ITKeyApi;

  canUseFileStorage: boolean;

  constructor() {
    this.moduleName = TORUS_STORAGE_MODULE_NAME;
  }

  setModuleReferences(tbSDK: ITKeyApi): void {
    this.tbSDK = tbSDK;
    this.tbSDK._setTorusStorage(this.storeTorusShare.bind(this));
  }

  // eslint-disable-next-line
  async initialize(): Promise<void> {
  }

  async inputShareFromTorusStorage(authDetails: AuthDetails, torusShare: string, postboxKey: string, polynomialId: string): Promise<unknown> {
    let latestShare = torusShare;

    if (!torusShare) {
      latestShare = await getShareFromLocalStorage(authDetails.verifier);
    }
    const torusShard = new Share(new BN(postboxKey, "hex"), new BN(latestShare, "hex"));
    const torusShareStore = new ShareStore(torusShard, polynomialId);
    this.tbSDK.inputShareStore(torusShareStore);
    return {
      latestShareStore: torusShareStore,
    };
  }

  async storeTorusShare(authDetails: AuthDetails, torusShare: string): Promise<unknown> {
    const latestShare = torusShare;
    await storeShareOnLocalStorage(latestShare, authDetails.verifier);
    return latestShare;
  }
}
export default TorusStorageModule;
